<template>
  <div>
    <div v-if="form" style="text-align: right;" dir="rtl">
      <div>
        <p class="bold">Key</p>
        <input class="outlined" v-model="form.data.language.fields.key.value">
      </div>
      <div>
        <p class="bold">Content</p>
        <input class="outlined" v-model="form.data.language.fields.content.value">
      </div>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  props: ['payload'],
  name: 'admin-question-infos-form',
  data () {
    return {
      languages: [],
      is_loading: false,
      form: undefined
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      if (this.payload.is_create) {
        this.setForm({
          id: ''
        })
        return
      }
      this.$network_utils.getQuestionInfo({ id: this.payload.data.id, question_id: this.payload.data.question_id }).then(response => {
        this.setForm(response)
      })
    },
    setForm (form_data) {
      this.form = new this.$form({
        language: {
          fields: {
            key: {
              value: form_data.key,
              has_error: false,
              validations: []
            },
            content: {
              value: form_data.content,
              has_error: false,
              validations: []
            },
            id: {
              value: form_data.id,
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: this.payload.is_create ? 'post' : 'put',
            url: '/questions/' + this.payload.data.question_id + '/infos/' + form_data.id,
            headers: 'admin_headers'
          },
          is_used: true
        }
      })
    },
    submit () {
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      this.is_loading = true
      response.promise.then((response) => {
        this.is_loading = false
        this.$utils.emit('show_toast', { text: 'success' })
        this.remove(this.payload)
      })
    },
    ...mapMutations('modals', ['remove'])
  }
}
</script>
